import script from "./addActivity.vue?vue&type=script&setup=true&lang=js"
export * from "./addActivity.vue?vue&type=script&setup=true&lang=js"

import "./addActivity.vue?vue&type=style&index=0&id=15f1b2a0&lang=scss"

const __exports__ = script;

export default __exports__